"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _clsx3 = _interopRequireDefault(require("clsx"));
var _useConvertLinksToRouter = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useConvertLinksToRouter"));
var _ReactTable = _interopRequireDefault(require("./ReactTable01.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var UiTable = (0, _component.default)(function () {
  return import("@material-ui/core/Table");
});
var TableBody = (0, _component.default)(function () {
  return import("@material-ui/core/TableBody");
});
var TableCell = (0, _component.default)(function () {
  return import("@material-ui/core/TableCell");
});
var TableContainer = (0, _component.default)(function () {
  return import("@material-ui/core/TableContainer");
});
var TableHead = (0, _component.default)(function () {
  return import("@material-ui/core/TableHead");
});
var TableRow = (0, _component.default)(function () {
  return import("@material-ui/core/TableRow");
});
var Typography = (0, _component.default)(function () {
  return import("@micado-digital/react-ui/components/Typography");
});
var TableWithSwipePopUp = (0, _component.default)(function () {
  return import("./tableWithSwipePopUp");
});
var ReactTable01 = function ReactTable01(_ref) {
  var addition = _ref.addition,
    _ref$footerComponent = _ref.footerComponent,
    footerComponent = _ref$footerComponent === void 0 ? "p" : _ref$footerComponent,
    _ref$footerVariant = _ref.footerVariant,
    footerVariant = _ref$footerVariant === void 0 ? "caption" : _ref$footerVariant,
    footerVariants = _ref.footerVariants,
    _ref$headlineComponen = _ref.headlineComponent,
    headlineComponent = _ref$headlineComponen === void 0 ? "h2" : _ref$headlineComponen,
    _ref$headlineVariant = _ref.headlineVariant,
    headlineVariant = _ref$headlineVariant === void 0 ? "h2" : _ref$headlineVariant,
    headlineVariants = _ref.headlineVariants,
    items = _ref.items,
    _ref$lang = _ref.lang,
    lang = _ref$lang === void 0 ? "de" : _ref$lang,
    _ref$sticky = _ref.sticky,
    sticky = _ref$sticky === void 0 ? true : _ref$sticky,
    title = _ref.title;
  var css = (0, _ReactTable.default)();
  var $table = (0, _react.useRef)(null);
  (0, _useConvertLinksToRouter.default)($table);
  if (!items.length > 0) {
    return null;
  }
  var headlines = items[0].map(function (row, counter) {
    var _clsx;
    return /*#__PURE__*/_react.default.createElement(TableCell, {
      className: (0, _clsx3.default)("mco-table-01__cell", css.tableHeaderCell, (_clsx = {}, _defineProperty(_clsx, css.tableCellSticky, counter === 0 && sticky), _defineProperty(_clsx, "mco-table-01__cell--sticky", counter === 0 && sticky), _clsx)),
      key: counter,
      align: row === null || row === void 0 ? void 0 : row.align,
      width: row === null || row === void 0 ? void 0 : row.width,
      dangerouslySetInnerHTML: {
        __html: row.text
      }
    });
  });
  var content = items.map(function (row, counter) {
    if (counter > 0) {
      var cells = row.map(function (cell, innerCounter) {
        var _clsx2;
        return /*#__PURE__*/_react.default.createElement(TableCell, {
          className: (0, _clsx3.default)("mco-table-01__cell", css.tableCell, (_clsx2 = {}, _defineProperty(_clsx2, css.tableCellSticky, innerCounter === 0 && sticky), _defineProperty(_clsx2, "mco-table-01__cell--sticky", innerCounter === 0 && sticky), _clsx2)),
          key: innerCounter,
          align: cell === null || cell === void 0 ? void 0 : cell.align,
          width: cell === null || cell === void 0 ? void 0 : cell.width,
          dangerouslySetInnerHTML: {
            __html: cell.text
          }
        });
      });
      return /*#__PURE__*/_react.default.createElement(TableRow, {
        className: "mco-table-01__row",
        key: counter
      }, cells);
    } else {
      return /*#__PURE__*/_react.default.createElement(TableCell, {
        className: "mco-table-01__cell",
        key: counter
      });
    }
  });
  content.shift();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-table-01",
    ref: $table
  }, /*#__PURE__*/_react.default.createElement(Typography, {
    className: (0, _clsx3.default)("mco-table-01__headline", css.headline),
    component: headlineComponent,
    dangerouslySetInnerHTML: {
      __html: title
    },
    variant: headlineVariant,
    variants: headlineVariants
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx3.default)("mco-table-01__wrapper", css.tableWrapper)
  }, /*#__PURE__*/_react.default.createElement(TableWithSwipePopUp, {
    lang: lang,
    children: /*#__PURE__*/_react.default.createElement(TableContainer, {
      className: css.container
    }, /*#__PURE__*/_react.default.createElement(UiTable, {
      className: (0, _clsx3.default)("mco-table-01__table", css.table),
      "aria-label": title
    }, /*#__PURE__*/_react.default.createElement(TableHead, {
      className: "mco-table-01__head"
    }, /*#__PURE__*/_react.default.createElement(TableRow, {
      className: "mco-table-01__row"
    }, headlines)), /*#__PURE__*/_react.default.createElement(TableBody, {
      className: "mco-table-01__body"
    }, content)))
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx3.default)("mco-table-01__footer", css.tableFooter)
  }, /*#__PURE__*/_react.default.createElement(Typography, {
    component: footerComponent,
    dangerouslySetInnerHTML: {
      __html: addition
    },
    variant: footerVariant,
    variants: footerVariants
  })));
};
ReactTable01.propTypes = {
  addition: _propTypes.default.string,
  footerComponent: _propTypes.default.string,
  footerVariant: _propTypes.default.string,
  footerVariants: _propTypes.default.object,
  headlineComponent: _propTypes.default.string,
  headlineVariant: _propTypes.default.string,
  headlineVariants: _propTypes.default.object,
  items: _propTypes.default.array.isRequired,
  lang: _propTypes.default.string,
  sticky: _propTypes.default.bool,
  title: _propTypes.default.string
};
var _default = ReactTable01;
exports.default = _default;